module.exports = __webpack_public_path__ + "static/media/EventPhoto7.18462c23.jpg";